import React, { useEffect, useState } from 'react';
import { LiveKitRoom } from '@livekit/components-react';
import { LIVEKIT_URL, fetchToken } from './livekitConfig';
import FloatingVideoStrip from './FloatingVideoStrip';
import ManualPublisher from './ManualPublisher';
import HostDebugPanel from './HostDebugPanel';
import HostFilterBroadcaster from '../filters/HostFilterBroadcaster';

const LiveKitProvider = ({
  roomName,
  identity,
  name,
  role = 'guest',
  socket = null,
  enabled = true,
  children,
}) => {
  const isHost = role === 'host';
  const [token, setToken] = useState(null);
  const [url, setUrl] = useState(LIVEKIT_URL);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !roomName || !identity) {
      setToken(null);
      return;
    }
    let cancelled = false;
    setError(null);
    fetchToken({ roomName, identity, name, role })
      .then((data) => {
        if (cancelled) return;
        setToken(data.token);
        if (data.url) setUrl(data.url);
      })
      .catch((e) => {
        if (cancelled) return;
        console.error('LiveKit token fetch failed:', e);
        setError(e.message || 'token fetch failed');
      });
    return () => {
      cancelled = true;
    };
  }, [roomName, identity, name, role, enabled]);

  if (!enabled) return <>{children}</>;

  if (error) {
    return (
      <>
        <div
          style={{
            position: 'fixed',
            bottom: 12,
            right: 12,
            zIndex: 50,
            padding: '8px 12px',
            fontFamily: 'var(--font-mono, monospace)',
            fontSize: 11,
            background: 'var(--c-cream, #fdd)',
            border: 'var(--border-ink-sm, 2px solid #c00)',
            borderRadius: 6,
            maxWidth: 240,
          }}
        >
          VIDEO OFF — {error}
        </div>
        {children}
      </>
    );
  }

  if (!token || !url) return <>{children}</>;

  return (
    <LiveKitRoom
      serverUrl={url}
      token={token}
      connect={true}
      video={false}
      audio={false}
      data-lk-theme="default"
      onError={(e) => {
        console.error('LiveKitRoom error:', e);
        setError(e?.message || 'connection error');
      }}
    >
      <ManualPublisher socket={socket} isHost={isHost} />
      {isHost && <HostFilterBroadcaster socket={socket} />}
      <HostDebugPanel isHost={isHost} />
      {children}
      <FloatingVideoStrip />
    </LiveKitRoom>
  );
};

export default LiveKitProvider;
